import { passos, preparacao } from '../data/conteudo';
import styles from './ComoFunciona.module.css';

const ComoFunciona = () => (
  <section id="como-funciona" className="secao" aria-labelledby="titulo-como-funciona">
    <div className={`container ${styles.grade}`}>
      <div>
        <h2 id="titulo-como-funciona">Como agendar sua consulta</h2>
        <ol className={styles.passos}>
          {passos.map((passo) => (
            <li key={passo.titulo}>
              <h3>{passo.titulo}</h3>
              <p>{passo.descricao}</p>
            </li>
          ))}
        </ol>
      </div>

      <aside className={styles.preparo} aria-labelledby="titulo-preparo">
        <h3 id="titulo-preparo">Para aproveitar bem a sessão</h3>
        <ul>
          {preparacao.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </aside>
    </div>
  </section>
);

export default ComoFunciona;
